import { DependencyList, useEffect } from 'react';

const debounceDelay = 400;

export const useDebounce = (callback: () => void, dependencies: DependencyList | undefined) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      callback();
    }, debounceDelay);

    return () => clearTimeout(timeoutId);
  }, dependencies);
};
